import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { Router } from '@angular/router';
import { TagColorEnum } from '@qaroni-app/tags/types/tag-color.enum';

@Component({
  selector: 'qaroni-projects-tasks-tags',
  templateUrl: './projects-tasks-tags.component.html',
  styleUrl: './projects-tasks-tags.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProjectsTasksTagsComponent {
  readonly tagClick = output<string>();
  readonly tagName = input.required<string>();
  readonly tagColor = input.required<string>();
  readonly redirectUrl = input<string>('');

  private router = inject(Router);

  get hasTagColor(): boolean {
    return this.tagColor() !== '';
  }

  get canRedirect(): boolean {
    return this.redirectUrl() !== '';
  }

  get defaultTagColor(): string {
    return this.hasTagColor ? this.tagColor() : '#E5E5E5';
  }

  get defaultTagTextColor(): string {
    return this.hasTagColor ? '#FFFFFF' : '#000000';
  }

  get routerLinkUrl(): string | null {
    return this.canRedirect ? this.redirectUrl() : null;
  }

  get ngClassRingColors() {
    return {
      'ring-green-800/10': this.tagColor() === TagColorEnum.GREEN,
      'ring-orange-800/10': this.tagColor() === TagColorEnum.ORANGE,
      'ring-red-800/10': this.tagColor() === TagColorEnum.RED,
      'ring-blue-800/10': this.tagColor() === TagColorEnum.BLUE,
      'ring-brown-800/10': this.tagColor() === TagColorEnum.BROWN,
      'ring-gray-800/10': !this.tagColor(),
    };
  }

  public onTagClick(): void {
    this.tagClick.emit(this.tagName());
  }
}
